import Vue from 'vue';

Vue.filter('money', function (number, text = 'R$ ') {
    return text + parseFloat(number).numberFormat(2, ',', '.')
});